module.exports = __webpack_public_path__ + "fonts/ionicons.05acfdb.woff";


//////////////////
// WEBPACK FOOTER
// ./~/iview/dist/styles/fonts/ionicons.woff?v=2.0.0
// module id = 1029
// module chunks = 14